import { useTranslation } from 'next-i18next';
import { FC } from 'react';

import { AuthEntryPoint } from '../../../features/auth/types';
import { useIsSubscribed } from '../../../hooks/subscription';
import { useAuthenticate } from '../../../hooks/useAuthenticate';
import { GeneratedSubscriptionType } from '../../../types/generated';
import { ButtonLocation } from '../../../types/Subscriptions';
import SubscribeBell from '../../SubscribeBell';

interface Props {
  buttonLocation: ButtonLocation;
  internalId: string;
  name: string;
  thumbnail: string;
}

export const ArtistSubscription: FC<Props> = ({
  buttonLocation,
  internalId,
  name,
  thumbnail,
}) => {
  const { t } = useTranslation('authentication');
  const { authenticateAndSubscribe } = useAuthenticate();

  const { checkIsSubscribed, refetch } = useIsSubscribed([
    { objectId: internalId, type: GeneratedSubscriptionType.Artist },
  ]);

  const isSubscribedToArtist = checkIsSubscribed(
    internalId,
    GeneratedSubscriptionType.Artist,
  );

  return (
    <SubscribeBell
      isSubscribed={isSubscribedToArtist}
      onClickSubscribe={async () => {
        await authenticateAndSubscribe({
          subscriptions: [
            {
              objectId: internalId,
              type: GeneratedSubscriptionType.Artist,
              name,
              ref: '',
            },
          ],
          authScreenThumbnail: thumbnail,
          authScreenTitle: t('authentication:dynamicTitle.artist'),
          analyticsProperties: {
            source: AuthEntryPoint.Artist,
            'artist name': name,
            button_location: buttonLocation,
          },
        });
        refetch();
      }}
    />
  );
};
